import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicidadIndexComponent } from './publicidad-index/publicidad-index.component';
import { PublicidadCreateComponent } from './publicidad-create/publicidad-create.component';
import { PublicidadUpdateComponent } from './publicidad-update/publicidad-update.component';
import { PublicidadViewComponent } from './publicidad-view/publicidad-view.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { PublicidadPreviewComponent } from './publicidad-preview/publicidad-preview.component';

const routes: Routes = [
  { path: 'index', component: PublicidadIndexComponent },
  { path: '', redirectTo: 'index', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    PublicidadIndexComponent,
    PublicidadCreateComponent,
    PublicidadUpdateComponent,
    PublicidadViewComponent,
    PublicidadPreviewComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
  ]
})
export class PublicidadModule { }
